import { NewsFeedModel } from './news-feed.model';

export class AccountModel {
    ID?: string;

    newsFeed?: Array<NewsFeedModel>;

    commonStatus?: string;
    createdBy?: string;
    createdTs?: Date;
    modBy?: string;
    modTs?: Date;
}

export class AccountDebtor {
    accountId?: string;
    lDebtorId?: number;
    propertyName?: string;
    debtorAccountName?: string;
    contractLotNo?: string;
}